import { render, staticRenderFns } from "./RHL.vue?vue&type=template&id=67bb3ff8&scoped=true"
import script from "./RHL.vue?vue&type=script&lang=js"
export * from "./RHL.vue?vue&type=script&lang=js"
import style0 from "./RHL.vue?vue&type=style&index=0&id=67bb3ff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bb3ff8",
  null
  
)

export default component.exports